<div class="c-randomprizeProgress">
  <div class="c-randomprizeProgress__container">
    <div
      class="c-randomprizeProgress__background"
      theming
      themingGroup="randomprize"
      themingAsset="start-background"
      [themingOverride]="event()?.assets">
      <div
        class="c-randomprizeProgress__icon"
        theming
        themingGroup="randomprize"
        themingAsset="logo"
        [themingOverride]="event()?.assets"></div>
      <div class="c-randomprizeProgress__info">
        <span class="text title">{{ 'home.live-ops.randomprize.modal-progress.title' | translate }}</span>
        <span class="text subtitle">{{ 'home.live-ops.randomprize.modal-progress.subtitle' | translate }}</span>
      </div>

      <slotcom-button
        class="c-button--pink"
        data-testid="random-prize-play-button"
        (safeClick)="openRandomprize()"
        audioType="functionality">
        {{ 'home.buttons.play' | translate | uppercase }}
      </slotcom-button>
    </div>
  </div>
</div>
